import '@/styles/globals.css';
import '../../node_modules/@rimactechnology/rimac-ui-lib/dist/style.css';

import { ApolloProvider } from '@apollo/client';
import type { AppProps } from 'next/app';
import Head from 'next/head';

import { useApollo, useArticleApollo } from '@/api/apolloClient';
import { CookieBar } from '@/components/cookies/CookieBar';
import { CookieSetting } from '@/components/cookies/CookieSetting';
import { Impressum } from '@/components/impressum/Impressum';
import { AnalyticsProvider } from '@/components/providers/AnalyticsProvider';

const App = ({ Component, pageProps }: AppProps) => {
  const client = useApollo(pageProps);
  const articleClient = useArticleApollo(pageProps);

  return (
    <ApolloProvider client={articleClient}>
      <ApolloProvider client={client}>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <title>Rimac Technology</title>
        </Head>
        <AnalyticsProvider>
          <Component {...pageProps} />
          {process.env.NEXT_PUBLIC_COOKIE_SETTINGS === 'enabled' && (
            <CookieBar key={'cookies-bar'} />
          )}
          <CookieSetting key="cookies-settings" />
          <Impressum key="impressum" />
        </AnalyticsProvider>
      </ApolloProvider>
    </ApolloProvider>
  );
};

export default App;
